module.exports = __webpack_public_path__ + "img/hyperfocus.ae81cd36.png";